import { Typography } from '@recruit-robin/robin-theme/web-components';
import { AlertTriangle } from '@recruit-robin/robin-theme/web-icons';
import { useContext } from 'react';
import { useContextSelector } from 'use-context-selector';

import { LocalizationContext } from 'shared/legacy/contexts/LocalizationContext/LocalizationContext';
import { EnrichVacancyModalContext } from '../../EnrichVacancyModalContext/EnrichVacancyModalContext';
import { EnrichVacancyModalType } from '../../EnrichVacancyModalContext/EnrichVacancyModalContext.types';
import { EnrichTab } from '../EditEnrichedVacancy.types';
import { EditEnrichedVacancyContext } from '../EditEnrichedVacancyContext/EditEnrichedVacancyContext';
import { useStyles } from './RenderTabs.styles';

export const RenderTabs = ({ activeTab }: { activeTab: EnrichTab }) => {
  const classes = useStyles();
  const { dictionary } = useContext(LocalizationContext);

  const modalType = useContextSelector(EnrichVacancyModalContext, (s) => s.modalType);
  const hasErrors = useContextSelector(EditEnrichedVacancyContext, (s) => s.enrichedVersion.hasErrors);

  const renderAlertMessage = (alertMessage: string) => (
    <div css={classes.errorMessage}>
      <AlertTriangle size={16} />
      <Typography variant={(v) => v.body.short} ellipsis inline>
        {alertMessage}
      </Typography>
    </div>
  );

  return (
    <div css={classes.root}>
      {activeTab === EnrichTab.JobPreview && renderAlertMessage(dictionary.visibleToCandidatesAsAttachment)}
      {activeTab === EnrichTab.EnrichedVersion && hasErrors && renderAlertMessage(dictionary.saveJobRequiredFields)}
      {activeTab === EnrichTab.JobDescription &&
        modalType === EnrichVacancyModalType.Ats &&
        renderAlertMessage(dictionary.atsContentWarning)}
    </div>
  );
};
